import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareInfo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-info, information, tooltip"} maskId="square-filled-radius-0-stroke-1-IconSquareInfo"><path fillRule="evenodd" clipRule="evenodd" d="M3 3V21H21V3H3ZM10 10H12.5L12.5 16L11.5 16L11.5 11H10V10ZM12.5 8H11.5V9H12.5V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareInfo;
